import { ReactNode, useState } from "react";

import { transferListViewModes } from "../../enums";
import { SwitchAppContentSwitcher } from "../../components";

export const TransfersViewModeSelector = (props: {
  defaultMode?: transferListViewModes;
  batchComponent: ReactNode;
  singlesComponent: ReactNode;
}) => {
  const [viewMode, setViewMode] = useState<transferListViewModes>(
    transferListViewModes.batchView
  );

  return (
    <>
      <SwitchAppContentSwitcher<transferListViewModes>
        onChange={({ name }) => {
          setViewMode(name);
        }}
        options={[
          {
            key: "Batch View",
            value: transferListViewModes.batchView,
          },
          {
            key: "Singles View",
            value: transferListViewModes.singlesView,
          },
        ]}
        selectedValue={viewMode}
      />

      {
        viewMode === transferListViewModes.batchView
          ? props.batchComponent // <Transfers />
          : props.singlesComponent // <SingleTransferNoBatchList />
      }
    </>
  );
};
